import { CSSProperties } from 'react';
import { CheckboxFormFieldComponent } from '@vivli/shared/components';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useFormContext } from 'react-hook-form';
import { PublishingRequestedStudyRowComponent } from './publishing-requested-study-row.component';

const sectionStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 5,
    paddingTop: 0,
};

const sectionStyleContainerConfig: CSSProperties = {
    ...sectionStyle,
    display: 'grid',
    justifyContent: 'space-around',
    gridTemplateColumns: '48px 1fr',
    columnGap: '48px',
};

interface PublishingRequestedStudyRowFormComponentProps {
    isConfigMode: boolean;
    index: number;
    arrayName: string;
}

export const PublishingRequestedStudyRowFormComponent = ({
    isConfigMode,
    index,
    arrayName,
}: PublishingRequestedStudyRowFormComponentProps) => {
    const { dataRequest } = useDataRequestContext();
    const formApi = useFormContext();
    const fieldName = `${arrayName}.${index}.`;
    const requestedStudyToShow = dataRequest.requestedStudies[index];
    const sectionStyleToUse = isConfigMode ? sectionStyleContainerConfig : sectionStyle;

    return (
        <>
            <div style={sectionStyleToUse}>
                {isConfigMode && (
                    <CheckboxFormFieldComponent name={`${fieldName}.publishable`} index={index} style={{ alignSelf: 'start' }} />
                )}
                <PublishingRequestedStudyRowComponent requestedStudy={requestedStudyToShow} index={index} isConfigMode={isConfigMode} />
            </div>
        </>
    );
};
